var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.33 4H6.67C5.2 4 4 5.19 4 6.66v18.67C4 26.8 5.19 28 6.66 28h18.67C26.8 28 28 26.81 28 25.34V6.67C28 5.2 26.81 4 25.34 4ZM12 22.67H8.64v-9.34H12v9.33Zm-1.74-11.04c-.88.07-1.64-.59-1.71-1.47v-.13c0-.9.75-1.62 1.65-1.61.06 0 .12 0 .18.01.88-.07 1.64.59 1.71 1.47v.13c0 .9-.75 1.62-1.65 1.61-.06 0-.12 0-.18-.01ZM24 22.67h-3.26v-5.1c0-1.41-.87-1.74-1.19-1.74s-1.41.22-1.41 1.74v5.1h-3.36v-9.34h3.36v1.3c.43-.76 1.3-1.3 2.93-1.3S24 14.63 24 17.56v5.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h32v32H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.6fc77aefa2f45b6fddc0bd16b8525526.svg";
export { ForwardRef as ReactComponent };